import React from 'react';
import {
  ActionIcon,
  Button,
  Group,
  Text,
  Tooltip,
} from '@mantine/core';
import { IconRefresh, IconPlus } from '@tabler/icons-react';
import type { ITablaCotizacionesVistaProps } from '../interfaces';
import Tabla from '../../../globales/componentes/tabla/tabla';
import FiltroCotizacionesVista from './filtroCotizacionesVista';

const TablaCotizacionesVista: React.FunctionComponent<ITablaCotizacionesVistaProps & { alCrearNueva?: () => void }> = ({
  tabla,
  consultarCotizaciones,
  filtro,
  manejarCambioFiltroCotizacion,
  habilitarFiltros,
  // manejarHabilitarFiltros,
  alCrearNueva
}) => {

  return (
    <>
      <Group justify="space-between" mb="md">
        <Text fw={700} size="lg">Cotizaciones NBS</Text>
        <Group>
          {alCrearNueva && (
            <Button 
              color="primary"
              variant="light"
              size="xs"
              radius="lg"
              leftSection={<IconPlus color="var(--mantine-color-primary-0)" size={12} />} 
              onClick={alCrearNueva}
            >
              <Text fw={500} size="xs">Nueva Cotización</Text>
            </Button>
          )}
          <Group gap={4}>
            <Tooltip
              label="Refrescar"
              withinPortal
              openDelay={100}
              zIndex={9999}
              style={{ fontSize: '10px', padding: '3px 5px' }}
            >
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={consultarCotizaciones}
              >
                <IconRefresh size={16} />
              </ActionIcon>
            </Tooltip>
            {/* <Tooltip
              label="Filtrar"
              withinPortal
              openDelay={100}
              zIndex={9999}
              style={{ fontSize: '10px', padding: '3px 5px' }}
            >
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={() => manejarHabilitarFiltros(!habilitarFiltros)}
              >
                {habilitarFiltros ? <IconFilterFilled size={16} /> : <IconFilter size={16} />}
              </ActionIcon>
            </Tooltip> */}
          </Group>
          </Group>
      </Group>

      {habilitarFiltros && (
        <FiltroCotizacionesVista
          consultarCotizaciones={consultarCotizaciones}
          filtro={filtro}
          manejarCambioFiltroCotizacion={manejarCambioFiltroCotizacion}
        />
      )}

      <Tabla maxHeight={habilitarFiltros ? 300 : 350} tabla={tabla} />
    </>
  );
};

export default React.memo(TablaCotizacionesVista);
